import { publicEnvSchema } from './env-schema'

const parsed = publicEnvSchema.parse(import.meta.env)

export const env = {
  apiHost: parsed.VITE_API_HOST,
  auth0Domain: parsed.VITE_AUTH0_DOMAIN,
  auth0ClientId: parsed.VITE_AUTH0_SPA_APP_CLIENT_ID,
  bugsnagApiKey: parsed.VITE_BUGSNAG_API_KEY,
  managerClientUrl: parsed.VITE_MANAGER_CLIENT_URL,
  posthogApiKey: parsed.VITE_POSTHOG_API_KEY,
  posthogApiUrl: parsed.VITE_POSTHOG_API_URL,
  mode: import.meta.env.MODE,
}
